import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Chip,
  Button,
} from '@mui/material';
import { CheckCircle as CheckIcon } from '@mui/icons-material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${API_URL}/notifications`);
      setNotifications(response.data.notifications || []);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const markAsRead = async (id) => {
    try {
      await axios.put(`${API_URL}/notifications/${id}/read`);
      fetchNotifications();
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const markAllAsRead = async () => {
    try {
      await axios.put(`${API_URL}/notifications/read-all`);
      fetchNotifications();
    } catch (error) {
      console.error('Error marking all as read:', error);
    }
  };

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" component="h1">
          Notifications
        </Typography>
        {notifications.some((n) => !n.is_read) && (
          <Button variant="outlined" onClick={markAllAsRead}>
            Mark All as Read
          </Button>
        )}
      </Box>

      {notifications.length === 0 ? (
        <Typography>No notifications</Typography>
      ) : (
        <Card>
          <List>
            {notifications.map((notification) => (
              <ListItem
                key={notification.id}
                sx={{
                  bgcolor: notification.is_read ? 'transparent' : 'action.hover',
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                }}
                secondaryAction={
                  !notification.is_read && (
                    <IconButton
                      edge="end"
                      onClick={() => markAsRead(notification.id)}
                    >
                      <CheckIcon />
                    </IconButton>
                  )
                }
              >
                <ListItemText
                  primary={
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography variant="subtitle1">{notification.title}</Typography>
                      <Chip label={notification.type} size="small" />
                    </Box>
                  }
                  secondary={notification.message}
                />
              </ListItem>
            ))}
          </List>
        </Card>
      )}
    </Container>
  );
};

export default Notifications;

